import React from 'react';
import { Page } from '../../components';
import { Typography } from '@mui/material';

export const NotFound = () => {
  return (
    <Page title={'404'}>
      <Typography variant="h4">404 Page Not Found</Typography>
      <Typography variant="body1">
        Contact support if you feel you have reached this in error.
      </Typography>
    </Page>
  );
};
